module.exports = __webpack_public_path__ + "static/img/ewm.612200d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewm.jpg
// module id = Wnh9
// module chunks = 1